import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Button, Divider, message, Checkbox } from 'antd';
import './list.less';
import { connect } from 'react-redux';
import DataDownload from './components/data-download';
import Container from '@/components/container';
import apis from '@/pages/activity-manage/apis';
import Conditions from './components/conditions';
import SelectSort, { optionPubEarly, optionActivityStart } from '@/form-component/select-sort';
import ComponentLog from '@/components/component-log';
import ConditionTips from '@/components/pagination-tips';
import ActivityListComponent from './components/list';
import CreateActivityAuthModal from '@/components/nopower/noPower-modal';
import { checkPowerCreateActivity } from '@/common/utils/helper';
import goTo from '@/common/goto';
import { CJ_LISTEN_YXHD_HQHDXX } from '@/constants/scene';
import FeedBackLayout from '@/components/feedback-layout';
import getBannerUrl from '@/common/goto/banner-url.js';
import SelectWhiteModel from '@/components/SpacialListConfig/selectWhiteModel';
import { useGetAuthRole } from '@/components/SpacialListConfig/getAuthRole';
import { getQuery } from '@/common/utils';

const selectSortOptions = [
  Object.assign({}, optionPubEarly, {
    getlog(value) {
      // valueDown2Top: 1, valueTop2Down: 2, valueInit: undefined
      if (value === 1) return 'hdgl_1603707393179|8';
      // 会存在1和2之外的值
      if (!value || value !== 2) return 'hdgl_1603707393179|7';
    },
  }),
  Object.assign({}, optionActivityStart, {
    getlog(value) {
      // options: { valueDown2Top: 3, valueTop2Down: 4, valueInit: undefined },
      if (value === 3) return 'hdgl_1603707393179|10';
      // 会存在3和4之外的值
      if (!value || value !== 4) return 'hdgl_1603707393179|9';
    },
  }),
];

function formatConditionsToQuery(conditions) {
  const res = {};
  Object.keys(conditions).forEach((key) => {
    if (conditions[key] !== '') res[key] = conditions[key];
  });
  return res;
}

const ActivityManageList = (props) => {
  const [banner, setBanner] = useState([]);
  const [data, setData] = useState({
    activityPlans: [],
    totalPage: 0,
    totalCount: 0,
    loading: false,
  });
  const [conditions, setConditions] = useState({
    currentPage: 1,
    pageSize: 10,
    planCode: '',
    status: '',
    level: '',
    isCreate: '',
    activityType: 1,
  });
  const [applyWhiteVisible, setApplyWhiteVisible] = useState(false);
  const authModalRef = useRef(null);

  const url = window.location.href;
  const openWhite = getQuery('openWhite', url);

  const isCustomerService = useMemo(() => {
    return props.roles?.some((role) => role.roleId === 26);
  }, [props.roles]);

  useEffect(() => {
    setApplyWhiteVisible(openWhite === '1');
  }, [openWhite]);

  useEffect(() => {
    let didMount = true;
    setData((data) => ({ ...data, loading: true }));
    apis
      .fetchMyActivityList(formatConditionsToQuery(conditions))
      .then((res) => {
        if (!didMount) return;
        const {
          ret,
          data: { activityPlans, totalPage, totalCount },
        } = res;
        if (ret === '0') {
          setData({
            activityPlans,
            totalCount,
            totalPage,
            loading: false,
          });
        } else {
          setData((data) =>
            Object.assign({}, data, {
              activityPlans: [],
              loading: false,
            })
          );
          message.error(res.msg);
        }
      })
      .catch((ex) => {
        setData((data) =>
          Object.assign({}, data, {
            activityPlans: [],
            loading: false,
          })
        );
      });
    return () => {
      didMount = false;
    };
  }, [conditions]);
  const ref = React.useRef();
  useEffect(() => {
    ref.current.show();
  }, []);

  useEffect(() => {
    apis
      .newBannerList({
        position: 6,
      })
      .then((res) => {
        if (res.ret === '0' && res.data) {
          setBanner(res?.data?.data || []);
        }
      });
  }, []);

  function commitSearch(query) {
    // 将活动评级和主推品类参数转为字符串用','连接的格式
    if (query.category) query.category = query.category.toString();
    if (query.level) query.level = query.level.toString();
    setConditions(Object.assign({}, conditions, query, { currentPage: 1 }));
  }

  function onPagesChange(toPage) {
    setConditions({
      ...conditions,
      currentPage: toPage,
    });
  }

  function updateConditions() {
    setConditions({ ...conditions }); // 商家端上下线操作后更新列表
  }

  const handleClick = (item) => {
    const { clickEvent, planCode, jumpUrl, questionnaireUrl } = item;
    switch (clickEvent) {
      case 1:
        goTo.merchantActivityDetail(planCode).push();
        break;
      case 2:
        window.open(jumpUrl);
        break;
      case 3:
        window.open(getBannerUrl(item));
        break;
      case 4:
        window.open(getBannerUrl(item));
        break;
      case 5:
        window.open(questionnaireUrl);
        break;
      default:
        return;
    }
  };

  const noPowerMessage = () => {
    authModalRef.current.show({ resCode: '5-1-1-1' });
  };

  const { showApplyBtn } = useGetAuthRole({ businessType: 1 });

  function openWhiteListConfigManage() {
    window.ACORE.openWhiteListDrawer.showManage({
      businessType: 1,
    });
  }

  const showManageBtn = window.ACORE.openWhiteListDrawer.showManageInter({ erp: props.erp });

  return (
    <div className="clearfix">
      {/* {useCargoOwnerMenuHide('主题活动', { activityTypeTags: ['playing_big_promotion'] })} */}
      <div className="body-wrapper">
        {banner.map((item, index) => {
          return (
            <ComponentLog key={index}>
              <img
                clstag="yx_clickofStudy_Manual_1663659008986|1"
                src={item.imageUrl}
                style={{ width: '100%', cursor: 'pointer', margin: '16px 24px' }}
                onClick={() => handleClick(item)}
              />
            </ComponentLog>
          );
        })}
        <FeedBackLayout
          showFeedBack={true}
          showConSult={true}
          showSurvey={true}
          scene={CJ_LISTEN_YXHD_HQHDXX.key}
          ref={ref}
        />

        {/* <ListGuide /> */}
        <Container margin={{ horizontal: true }} marginSize="max">
          <Conditions onChange={(value) => commitSearch(value)} addCreator={isCustomerService} />
          <Divider className="new-activity-form-divider" />
        </Container>
        <div className="new-activity-btn-wrapper">
          <div className="new-activity-btn-wrapper-title">
            <Checkbox
              checked={conditions.activityType == 1}
              onChange={(e) => commitSearch({ activityType: e.target.checked ? 1 : '' })}
            >
              仅看正式活动
            </Checkbox>
            <Checkbox onChange={(e) => commitSearch({ isCreate: e.target.checked ? 1 : '' })}>
              仅看我创建的活动
            </Checkbox>
            <SelectSort
              onChange={(val) => commitSearch({ order: val })}
              value={conditions.order}
              options={selectSortOptions}
            />
          </div>
          {isCustomerService ? null : (
            <div className="new-activity-btn-wrapper-operat">
              <ComponentLog>
                {showApplyBtn && (
                  <Button clstag="yx_whiteapply_page_1706591686206|13" onClick={() => setApplyWhiteVisible(true)}>
                    白名单申请
                  </Button>
                )}
              </ComponentLog>
              {showManageBtn && (
                <ComponentLog clstag="yx_whiteapply_page_1706591686206|12">
                  <Button onClick={() => openWhiteListConfigManage()}>白名单管理</Button>
                </ComponentLog>
              )}
              <DataDownload />

              <ComponentLog>
                <Button
                  clstag="yx_center_1629184833805|27"
                  onClick={() => {
                    props.checkPowerCreateActivity(() => goTo.merchantActivityCreate().push(), noPowerMessage);
                  }}
                  type="primary"
                  shape="round"
                >
                  +&nbsp;新建活动
                </Button>
              </ComponentLog>
            </div>
          )}
        </div>
        <Divider className="new-activity-btn-wrapper-bottom-divider" />
        <ActivityListComponent
          userType={props.userType}
          data={data}
          conditions={conditions}
          onPagesChange={onPagesChange}
          updateConditions={updateConditions}
          history={props.history}
          hideMore={isCustomerService}
        />
        <ConditionTips current={conditions.currentPage} pageSize={conditions.pageSize} />
        <CreateActivityAuthModal ref={authModalRef} />
        <SelectWhiteModel
          selectWhiteModalVisible={applyWhiteVisible}
          setSelectWhiteModalVisible={setApplyWhiteVisible}
          businessType={1}
        />
      </div>
    </div>
  );
};

export default connect((state) => {
  if (!state.userInfo.userMap || !state.userInfo.userMap.erp) return {};
  return {
    erp: state.userInfo.userMap.erp,
    checkPowerCreateActivity(resolve, reject) {
      return checkPowerCreateActivity(state.userInfo, resolve, reject);
    },
    userType: state.userInfo.userMap.userType, //用户类型，0：普通用户 1：活动管理者（活动管理员、超管） 2：采销
    roles: state.userInfo.roles || [], // 角色列表
  };
})(ActivityManageList);
